// A request that never got a response (axios "Network Error", status 0) is
// what the app webview produces for its first calls after resuming from the
// background, before the network is back. One delayed retry recovers it; an
// answer from the server (any status) is final and is never retried.
export const NETWORK_RETRY_DELAY_MS = 1000;

export function isNetworkError(error) {
  return !!error && !error.response;
}

export async function retryOnNetworkError(request) {
  try {
    return await request();
  } catch (error) {
    if (!isNetworkError(error)) throw error;

    await new Promise(resolve => setTimeout(resolve, NETWORK_RETRY_DELAY_MS));
    return request();
  }
}
